<style lang="sass" scoped>
  @import '../../../sass/variables'

  h6
    height: 30px
    color: $salesflow-font-gray
    font-size: 0.75rem
    line-height: 130%
    font-weight: 600

  table
    th
      color: $salesflow-font-dark
      font-weight: 600
      font-size: 0.75rem
      padding-bottom: 6px

    td
      font-size: 0.75rem
      color: $salesflow-font-dark
      line-height: 130%
      font-weight: 400

      a
        text-decoration: underline
</style>

<template>
  <div class="row">
    <div
      class="col"
      v-for="(stats, index) in data"
      :key="index"
    >
      <h6 class="text-center">
        {{ stats.title }}
      </h6>
      <table class="m-auto w-80">
        <tr>
          <th>{{ __(stats.columns[0]) }}</th>
          <th class="text-center">
            {{ __(stats.columns[1]) }}
          </th>
        </tr>
        <tr
          v-for="data in stats.data"
          :key="data.name"
        >
          <td>
            <a
              :href="data.href || '#'"
              :title="data.name"
              :target="data.href ? '_blank' : '_self'"
            >{{ data.name | truncate }}</a>
          </td>
          <td class="text-center">
            {{ data.total | number(0) }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Widget from '../../mixins/widget';

export default {
  props: ['user', 'range'],

  mixins: [Widget],

  data () {
    return {
      name: 'top5',
      loading: true,
      error: false,
      data: {},
    };
  },
};
</script>
